<template>
    <dashboard-layout-v2>
        <login slot="login-view"></login>
        <template slot="sidebar-menu">
            <sidebar-link
                index="1"
                name="Dashboard"
                i="ti-layout-media-overlay"
                to="dashboard"
            >
            </sidebar-link>
            <sidebar-link
                v-if="$store.getters.userIsAtLeastManager"
                index="2"
                name="Monitoring"
                i="ti-stats-up"
                to="monitoring"
            ></sidebar-link>
            <sidebar-link
                index="3"
                name="Entities"
                i="ti-world"
                to="entities"
            >
            </sidebar-link>
            <sidebar-link
                index="4"
                name="Universes"
                i="ti-folder"
                to="universes"
            >
            </sidebar-link>
            <sidebar-link
                index="5"
                name="Events"
                i="ti-cup"
                to="events"
            >
            </sidebar-link>
            <sidebar-link
                index="6"
                name="Channels"
                i="ti-desktop"
                to="channels"
            ></sidebar-link>
            <sidebar-link
                index="7"
                name="Channels Overview"
                i="ti-stats-up"
                to="channels-overview"
            ></sidebar-link>
            <sidebar-link
                index="8"
                name="Feeds Resources"
                i="ti-video-camera"
                to="feed-resources"
            >
            </sidebar-link>
            <sidebar-link
                index="9"
                name="Feeds R. Overview"
                i="ti-stats-up"
                to="feed-resources-overview"
            >
            </sidebar-link>
            <sidebar-link
                index="10"
                name="Feeds"
                i="ti-video-camera"
                to="feeds"
            >
            </sidebar-link>
            <div class="sidebar-link">
                <router-link
                    :to="{ name: 'booking-mismatch'}"
                    tag="div"
                >
                    <el-menu-item
                        index="11"
                        :class="[$route.name === 'booking-mismatch' ? 'is-active': 'is-inactive']"
                    >
                        <el-badge
                            :value="mismatchCount"
                            class="mismatch-badge"
                            :max="99"
                            :hidden="mismatchCount === 0"
                        >
                            <i class="ti-split-h"></i>
                            <span v-if="!(burgerMenuAllowedAndClosed)">Mismatch</span>
                        </el-badge>
                    </el-menu-item>
                </router-link>
            </div>
            <sidebar-link
                index="12"
                name="Takers"
                i="ti-user"
                to="takers"
            >
            </sidebar-link>
            <sidebar-link
                index="13"
                name="Receivers"
                i="ti-harddrives"
                to="receivers"
            >
            </sidebar-link>
            <sidebar-link
                index="14"
                name="Groups"
                i="ti-medall"
                to="right-group"
            >
            </sidebar-link>
            <sidebar-link
                index="15"
                name="Usage"
                i="ti-dashboard"
                to="consumption"
            ></sidebar-link>
            <sidebar-link
                v-if="$store.getters.userIsAtLeastAdmin"
                index="16"
                name="Admin notification"
                i="ti-pulse"
                to="admin-notification"
            ></sidebar-link>
        </template>
    </dashboard-layout-v2>
</template>

<script>
import {DashboardLayoutV2} from 'fundation-app-vuejs';
import { Login } from 'gcmcn-common';
import { mapGetters } from 'vuex';

export default {
    name: 'App',
    components: {
        DashboardLayoutV2,
        Login,
    },
    data (){
        return {
            mismatchCount: 0,
            idTimeoutMismatchCount: null,
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'burgerMenuAllowedAndClosed',
        ]),
    },
    created (){
        this.$store.dispatch('setNowUtc');
    },
    mounted (){
        window.app = this;
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
        this.onResize();
        this.getMismatchCount();
    },
    methods: {
        onResize() {
            this.$store.commit('BROWSER_RESIZED', document.documentElement.clientWidth);
        },

        getMismatchCount (){
            clearTimeout(this.idTimeoutMismatchCount);
            this.$store.dispatch('remoteGet', {url: 'booking-mismatch/stats/?resolved=false&archived=false'}).then((res) => {
                this.mismatchCount = res.data.objects_count;
            }).catch((e) => {
                console.error(e);
            }).finally(() => {
                this.idTimeoutMismatchCount = setTimeout(this.getMismatchCount, 30000);
            });
        }
    },
};
</script>

<style lang="scss">
@import './main.scss';
html, body{
    margin: 0px;
    padding: 0px;
    height: calc( 100vh - 65px) !important;
}
.mismatch-badge{
    .el-badge__content{
        top: 20px !important;
        right: 2px !important;
    }
}
div::-webkit-scrollbar {
    width: 7px;
}
div::-webkit-scrollbar-thumb {
    width: 7px;
    margin-left: 3px;
    border-radius: 15px;
    background-color: rgba(50, 50, 50, 1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue